import { css } from '../../../styles/theme';

export const StylesOV = css`
    button {
        &:hover {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    .linkButton {
        border-bottom: 1px solid transparent;
        color: ${({ theme }) => theme.colors.black};
        font-weight: bold;
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        &:hover,
        &:focus-visible {
            border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
        }
    }

    .noLinkButton {
        background: ${({ theme }) => theme.colors.pureWhite};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        font-size: ${({ theme }) => theme.fontSizes.textMedium};

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.black};
            border-color: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.pureWhite};
        }
    }
`;
